























import { Component, Prop, Vue } from "vue-property-decorator";
const { DateTime } = require("luxon");
import Vehicle from "../../models/vehicle";

@Component
export default class VehicleHistoryCard extends Vue {
  page = 1;
  totalPages = 1;

  @Prop() readonly vehicle!: Vehicle;

  items: any[] = [
    {
      color: "grey",
      icon: "domain",
      title: "Vin Assigned",
      subtitle: "Toyota Motor Manufacturing Kentucky",
      datetime: "2020-09-23T00:00:00Z",
    },
    {
      color: "grey",
      icon: "domain",
      title: "Vehicle Manufactured",
      subtitle: "Toyota Motor Manufacturing Kentucky",
      datetime: "2020-09-26T00:00:00Z",
    },
    {
      color: "green",
      icon: "payments",
      title: "First Sale",
      subtitle: "Tyler's Toyota of Addison",
      datetime: "2020-12-15T00:00:00Z",
    },
    {
      color: "red",
      icon: "warning",
      title: "Recall Issued",
      subtitle: "20V331000 - Brake pad chassis failure.",
      datetime: "2021-02-09T00:00:00Z",
    },
    {
      color: "orange",
      icon: "build_circle",
      title: "Service Performed",
      subtitle: "Recall Repair: 20V331000",
      datetime: "2021-04-01T00:00:00Z",
    },
  ];

  datetimeString(datetime: string): string {
    return DateTime.fromISO(datetime).toLocaleString(DateTime.DATE_FULL);
  }
}
